module.exports = __webpack_public_path__ + "img/gallery-post.ae80068c.jpg";